var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAg = function SvgAg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-79.698 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(74.717) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-120 0h763.27v511.49H-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.31.617h760.88v216.09h-760.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061ff",
    d: "M21.3 203.23h505.01v113.82H21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.75 1.753v510.25H262.03L642.75 1.753z",
    fill: "#e20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.69 1.753v510.25h380.72L-118.69 1.753z",
    fill: "#e20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.37 203.34l-76.31-19.363L428.98 135l-79.726 11.39 41.003-69.475-70.616 41.003 12.53-80.867-47.837 63.783L264.97 26.8l-21.64 76.31-47.837-64.92 13.667 83.145-70.615-43.282 41.003 69.476-77.45-12.53 63.783 47.838-79.727 20.5h354.22z",
    fill: "#ffd600"
  }))));
};
export default __webpack_public_path__ + "assets/231f9400b2f7887b25b91eff54c2b05a.svg";
export { SvgAg as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ag.svg